
    <h3>Properties</h3>
    <div *ngIf="vertex; else propertiesMsg">
      <p>
        Following properties are available for the selected vertex.
      </p>

      <ui-type-interface-form *ngIf="typeData" [typeData]="typeData" (formInitialized)="formInitialized($event)"
                              #interfaceForm></ui-type-interface-form>

      <section *ngIf="!vertex.incoming.empty">
        <h3>Incoming Edges</h3>
        <wf-designer-vertex-connection *ngFor="let edge of incomingEdges" [direction]="'in'"
                                       (removed)="onEdgeRemoved($event)"
                                       (moved)="onEdgeMoved($event)"
                                       [edge]="edge"></wf-designer-vertex-connection>
      </section>

      <section *ngIf="!vertex.outgoing.empty">
        <h3>Outgoing Edges</h3>
        <wf-designer-vertex-connection *ngFor="let edge of outgoingEdges" [direction]="'out'"
                                       (removed)="onEdgeRemoved($event)"
                                       (moved)="onEdgeMoved($event)"
                                       [edge]="edge"></wf-designer-vertex-connection>
      </section>

      <section class="buttons">
        <button class="btn btn-outline-danger btn-sm" (click)="onVertexRemove()">Remove</button>
      </section>

    </div>

    <ng-template #propertiesMsg>
      <p class="text-center">
        Once an item is selected on the canvas, based on its type - the properties will be displayed here.
      </p>
    </ng-template>

    <ui-overlay [visible]="!!overlayMessage">
      <h3>{{ overlayMessage }}</h3>
    </ui-overlay>
  


// WEBPACK FOOTER //
// ./src/library/designer/vertex/workflow-designer-vertex-properties.component.ts.WorkflowDesignerVertexPropertiesComponent.html